<app-header></app-header>
<div class="app-body">
  <app-sidebar></app-sidebar>
  <!-- Main content -->
  <main class="main">
    <!-- Breadcrumb -->
    <ol class="breadcrumb d-print-none">
      <app-breadcrumbs></app-breadcrumbs>
      <!-- Breadcrumb Menu-->
      <li class="breadcrumb-menu">
        <div class="btn-group" role="group" aria-label="Button group with nested dropdown">
          <a class="btn text-primary" (click)="onBack()" href="#"><i class="fa fa-arrow-circle-left fa-md"></i> <span class=" d-md-down-none">&nbsp;Back</span></a>
          <a class="btn text-primary" (click)="onForward()" href="#"><i class="fa fa-arrow-circle-right fa-md"></i> <span class=" d-md-down-none">&nbsp;Forward</span></a>
          <a class="btn text-primary" (click)="onRefresh()" href="#"><i class="fa fa-refresh fa-md"></i></a>
        </div>
      </li>
    </ol>
    <div class="container-fluid">
      <router-outlet></router-outlet>
    </div><!-- /.conainer-fluid -->
  </main>
  <!-- <app-aside></app-aside> -->
</div>
<app-footer></app-footer>
